module.exports = __webpack_public_path__ + "img/sen-sports.7315f55f.png";